<template>
<svg viewBox="0 0 130 130" xmlns="http://www.w3.org/2000/svg" :class="[`${prefix}-icon`, `${prefix}-icon-psm-xtbb`]" width="1em" height="1em" v-bind="$attrs"><path d="M73.759109,0 L100,30.0726506 L100,109.879518 C100,112.155197 98.1532439,114 95.8751547,114 L4.1248453,114 C1.84675615,114 0,112.155197 0,109.879518 L0,4.12048191 C0,1.84480259 1.84675615,0 4.1248453,0 L73.759109,0 Z M70.0054998,8.24096381 L8.2496906,8.24096381 L8.2496906,105.759036 L91.7503094,105.759036 L91.7503094,33.163012 L70.0054998,8.24096381 Z M69.9828294,76.7407082 L69.9828294,85 L29.0376843,85 L29.0376843,76.7407082 L69.9828294,76.7407082 Z M65.1894849,30 L72,34.6045551 L49.5102568,68.309348 L27,34.6183207 L33.8036773,30.0137655 L49.503419,53.5045676 L65.1894849,30 Z" transform="translate(15 8)" :fill="useCurrentColor ? 'currentColor' : '#4E5969'" fill-rule="nonzero"/></svg>
</template>
<script>

export default {
  name: 'IconPsmXtbb',
  props: {
    prefix: {
        type: String,
        default: 'psm',
    },
    useCurrentColor: {
        type: Boolean,
        default: false,
    },
  },
};
</script>
